module.exports = __webpack_public_path__ + "img/26.73e23e74.png";